<div class="flex justify-between items-center px-4 py-3 rounded-xl cursor-pointer font-semibold border border-gray-200 select-none" 
    [ngClass]="{'rounded-b-xl': !isOpen, 'rounded-b-none': isOpen, 'transition-[border-radius] duration-300 ease-in-out': true}"
    (click)="toggleDropdown()">
  <span class="text-base text-gray-800 flex justify-center items-center">
    <ng-container *ngIf="titleTemplate; else noTitle">
      <ng-container *ngTemplateOutlet="titleTemplate; context: titleTemplateContext"></ng-container>
    </ng-container>
    <ng-template #noTitle></ng-template>
  </span>
  <span class="text-lg text-gray-500 transform transition-transform duration-300" [ngClass]="{'rotate-180': isOpen}">
    <svg width="28px" height="28px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L6.29289 9.70711C5.90237 9.31658 5.90237 8.68342 6.29289 8.29289C6.68342 7.90237 7.31658 7.90237 7.70711 8.29289L12 12.5858L16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711L12.7071 14.7071Z" fill="#636363"></path> </g></svg>
  </span>
</div>
<div
  class="px-4 py-4 border border-t-0 border-gray-200 rounded-b-xl bg-white transform origin-top transition-all duration-300 overflow-hidden"
  [ngClass]="{
    'max-h-fit scale-100 opacity-100 pointer-events-auto mb-4': isOpen,
    'max-h-0 scale-95 opacity-0 pointer-events-none': !isOpen
  }"
>
  <ng-content [ngClass]="{'opacity-100': isOpen, 'opacity-0': !isOpen}"></ng-content>
</div>
